import { render } from "./MemoIcon.vue?vue&type=template&id=2538c861"
const script = {}

import exportComponent from "../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/MemoIcon.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2538c861"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2538c861', __exports__)) {
    api.reload('2538c861', __exports__)
  }
  
  module.hot.accept("./MemoIcon.vue?vue&type=template&id=2538c861", () => {
    api.rerender('2538c861', render)
  })

}


export default __exports__